import { Provider } from 'react-redux'
import { store } from '@/store/index'

export default ({ element }: { element: JSX.Element | JSX.Element[] }) => (
  <Provider store={store}>{element}</Provider>
)
